var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 58,
    viewBox: "0 0 56 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1123_138825)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 44,
    height: 44,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_1123_138825)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint1_linear_1123_138825)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "url(#paint2_linear_1123_138825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 19.9992C28.578 19.9992 31.9991 18.1892 31.9991 16.5708C31.9991 14.9526 28.5779 13.1426 23.9995 13.1426C19.4211 13.1426 16 14.9526 16 16.5708C16 18.1892 19.421 19.9992 23.9995 19.9992Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 33.7131C24.6678 33.7131 25.311 33.6742 25.9228 33.6035C25.4071 32.9407 24.9806 32.2052 24.6611 31.4153C24.4415 31.4227 24.2213 31.4278 23.9994 31.4278C21.3833 31.4278 18.9058 30.9094 17.0234 29.9682C16.6528 29.7829 16.3117 29.5838 16 29.373V30.2848C16 31.9031 19.421 33.7131 23.9995 33.7131Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 29.1408C24.0231 29.1408 24.0462 29.1405 24.0695 29.1404C24.0227 28.7658 23.9982 28.3843 23.9982 27.9972C23.9982 27.6102 24.0226 27.2289 24.0695 26.8546C24.0462 26.8546 24.023 26.8555 23.9996 26.8555C21.3835 26.8555 18.906 26.3371 17.0236 25.3959C16.6529 25.2106 16.3117 25.0115 16 24.8008V25.7125C16.0001 27.3308 19.4211 29.1408 23.9996 29.1408Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 24.5705C24.2264 24.5705 24.4501 24.5659 24.671 24.5572C25.0258 23.6868 25.5106 22.8828 26.1018 22.1698C25.4174 22.2452 24.714 22.2852 23.9996 22.2852C21.3835 22.2852 18.906 21.7669 17.0236 20.8257C16.6529 20.6403 16.3117 20.4412 16 20.2305V21.1423C16.0001 22.7606 19.4211 24.5705 23.9996 24.5705Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4285 24.2101C26.9339 24.9536 26.5806 25.7986 26.4068 26.7066C26.3265 27.1251 26.2842 27.557 26.2842 27.9985C26.2842 28.3305 26.3084 28.657 26.3542 28.9765C26.4668 29.7614 26.7126 30.5036 27.0682 31.1797C27.4413 31.8892 27.9348 32.5258 28.5218 33.0619C29.7416 34.176 31.3638 34.8564 33.1421 34.8564C36.9235 34.8564 40 31.78 40 27.9985C40 24.217 36.9235 21.1406 33.1421 21.1406C32.7513 21.1406 32.3681 21.174 31.9948 21.2371C30.0938 21.5586 28.4565 22.6649 27.4285 24.2101Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1123_138825",
    x: 0,
    y: 0,
    width: 56,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1123_138825"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1123_138825",
    result: "effect2_dropShadow_1123_138825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1123_138825",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1123_138825",
    x1: 1.98955,
    y1: -17.2312,
    x2: 22.1023,
    y2: 16.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1123_138825",
    x1: 36.8993,
    y1: 39.4189,
    x2: 56.9344,
    y2: 65.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1123_138825",
    x1: 2.14737,
    y1: -17.3294,
    x2: 28,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.d6b02f1200e0f0478197ad3e22a3ba87.svg";
export { ForwardRef as ReactComponent };